import VisibilityOffOutlinedIcon from "@mui/icons-material/VisibilityOffOutlined";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import { type ReactNode, useState } from "react";

import { getNestedChildText } from "../../../utils/utils";
import { CopyButton } from "./CopyButton";

const mask = "**********";

export function MaskValue({
  children,
  unmaskValue,
}: {
  children: ReactNode;
  unmaskValue: () => Promise<string>;
}) {
  const [displayValue, setDisplayValue] = useState(false);
  const [unmaskedText, setUnmaskedText] = useState<string | null>(null);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        width: "100%",
        justifyContent: "space-between",
        "div:first-child": {
          width: "100px",
          textOverflow: "ellipsis",
          overflow: "hidden",
          whiteSpace: "nowrap",
        },
      }}
    >
      {displayValue ? (
        <div data-sr-redact>{unmaskedText || children}</div>
      ) : (
        <div>{mask}</div>
      )}
      <div>
        <CopyButton
          getText={async () => {
            if (!displayValue) {
              const unmasked = await unmaskValue();
              setUnmaskedText(unmasked);
              return unmasked !== mask ? unmasked : null;
            }
            return unmaskedText || getNestedChildText(children);
          }}
        />
        <IconButton
          aria-label="toggle password"
          size="small"
          sx={{ color: "#475467", padding: "5px" }}
          onClick={async () => {
            if (!displayValue) {
              const unmasked = await unmaskValue();
              setUnmaskedText(unmasked);
            }
            setDisplayValue(!displayValue);
          }}
        >
          {displayValue ? (
            <VisibilityOffOutlinedIcon sx={{ width: "20px", height: "20px" }} />
          ) : (
            <VisibilityOutlinedIcon sx={{ width: "20px", height: "20px" }} />
          )}
        </IconButton>
      </div>
    </Box>
  );
}
